/*
 * @Author: your name
 * @Date: 2021-04-06 15:22:29
 * @LastEditTime: 2021-07-28 11:51:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\andPackage.js
 */
export default [
    {
      path: '/andPackage',
      component: resolve => require(['../../views/andPackage/index'], resolve),
      meta: {
        title: '和包'
      }
    },
    {
      path: '/andPackAccountList',
      component: resolve => require(['../../views/andPackage/andPackAccountList'], resolve),
      meta: {
        title: '和包账户'
      }
    },
    
    {
      path: '/theDetail',
      component: resolve => require(['../../views/andPackage/theDetail/theDetail'], resolve),
      meta: {
        title: '收支明细'
      }
    },
    {
      path: '/paymentReview',
      component: resolve => require(['../../views/paymentReview/paymentReview'], resolve),
      meta: {
        title: '付款审核'
      }
    },
  ]


// WEBPACK FOOTER //
// ./src/TASMini/router/modules/andPackage.js